export default "__VITE_ASSET__3a514f0d__"